import * as React from "react";
import type { SVGProps } from "react";
const SvgReduce = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M.405 32.286H26.07l2.277 3.404c1.68 2.51 5.411 2.421 6.969-.166l1.95-3.238h26.428l-.103.964c-1.306 12.234-6.822 19.95-13.236 24.59C43.972 62.456 36.746 64 32 64h-.045l-.045-.005c-12.522-1.3-20.424-6.678-25.183-12.934C1.99 44.834.405 37.789.405 33.158v-.872Zm1.77 1.744c.187 4.292 1.76 10.474 5.947 15.978 4.451 5.852 11.895 10.989 23.923 12.248 4.43-.01 11.258-1.47 17.281-5.827 5.847-4.23 10.979-11.22 12.411-22.399H38.256l-1.44 2.391c-2.22 3.685-7.534 3.811-9.927.236l-1.757-2.627H2.175Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M32 62.022c16.707 0 30.25-13.494 30.25-30.14C62.25 15.238 48.707 1.745 32 1.745S1.75 15.237 1.75 31.883c0 16.645 13.543 30.14 30.25 30.14Zm0 1.744c17.673 0 32-14.275 32-31.883C64 14.275 49.673 0 32 0 14.327 0 0 14.274 0 31.883 0 49.49 14.327 63.766 32 63.766Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M30.271 24.051a3.463 3.463 0 0 1 4.722 1.26 3.437 3.437 0 0 1-1.265 4.704 3.463 3.463 0 0 1-4.722-1.26 3.437 3.437 0 0 1 1.265-4.704Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M33.477 26.183a1.71 1.71 0 0 0-2.33-.622 1.697 1.697 0 0 0-.625 2.322 1.71 1.71 0 0 0 2.33.623 1.697 1.697 0 0 0 .625-2.323Zm1.516-.872a3.463 3.463 0 0 0-4.722-1.26 3.437 3.437 0 0 0-1.265 4.704 3.463 3.463 0 0 0 4.722 1.26 3.437 3.437 0 0 0 1.265-4.704Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M24.48 21.284a.877.877 0 0 1 1.226-.175l4.196 3.136a.87.87 0 0 1 .175 1.22.877.877 0 0 1-1.225.175l-4.196-3.136a.87.87 0 0 1-.175-1.22Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M31.324 5.74C13.44 7.014 8.13 21.044 7.68 28.058c6.144-14.284 18.098-17.43 23.644-17.217C46.08 11.407 48 23.594 48.64 28.058h9.6C53.76 10.204 39.658 5.146 31.324 5.74Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M56.848 26.994C52.165 10.784 39.083 6.255 31.4 6.801c-8.637.615-14.162 4.292-17.6 8.607a23.674 23.674 0 0 0-3.22 5.41c6.665-9.004 15.922-11.226 20.785-11.04 7.73.297 12.215 3.67 14.805 7.63 2.233 3.413 3.016 7.199 3.39 9.586h7.288ZM31.248 4.68c8.781-.625 23.405 4.7 28.027 23.121.08.318.008.654-.194.913a1.069 1.069 0 0 1-.841.409h-9.6c-.531 0-.982-.39-1.057-.913-.32-2.227-.938-6.18-3.202-9.64-2.219-3.392-6.073-6.396-13.098-6.665-5.18-.198-16.68 2.76-22.622 16.573a1.068 1.068 0 0 1-2.046-.487c.236-3.69 1.74-9.167 5.513-13.905 3.801-4.771 9.873-8.747 19.12-9.406ZM45.093 45.745H20.828a.25.25 0 0 0-.25.25v4.297c0 .138.112.25.25.25h24.265a.25.25 0 0 0 .25-.25v-4.297a.25.25 0 0 0-.25-.25Zm-24.265-1.743c-1.104 0-2 .892-2 1.993v4.297c0 1.1.896 1.993 2 1.993h24.265c1.104 0 2-.892 2-1.993v-4.297c0-1.1-.896-1.993-2-1.993H20.828Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgReduce;
